import { render, staticRenderFns } from "./SimpleDisplayLocation.vue?vue&type=template&id=2b4d00b5&scoped=true"
import script from "./SimpleDisplayLocation.vue?vue&type=script&lang=js"
export * from "./SimpleDisplayLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d00b5",
  null
  
)

export default component.exports